import { api } from './api';

export const featuresApi = api.injectEndpoints({
  endpoints: (build) => ({
    getFeatures: build.query({
      query: () => ({
        url: `features`,
      }),
      providesTags: (_result, _err, _id) => [{ type: 'Features', id: 'LIST' }],
      transformResponse: (response) => {
        return response.data;
      },
    }),
    getAdminFeatures: build.query({
      query: () => ({
        url: `admin/features`,
      }),
      providesTags: (_result, _err, _id) => [{ type: 'AdminFeatures', id: 'LIST' }],
      transformResponse: (response) => {
        return response.data;
      },
    }),
    updateAdminFeatures: build.mutation({
      query: ({id, feature}) => ({
        url: `admin/features/${id}`,
        method: 'PUT',
        body: {...feature, settings: JSON.stringify(feature.settings || [])},
      }),
      invalidatesTags: [{ type: 'AdminFeatures', id: 'LIST' }],
    }),
  }),
});


export const {
  useGetFeaturesQuery,
  useGetAdminFeaturesQuery,
  useUpdateAdminFeaturesMutation
} = featuresApi;
